import { render, staticRenderFns } from "./EditDetails.vue?vue&type=template&id=2bdf413e&scoped=true&"
import script from "./EditDetails.vue?vue&type=script&lang=ts&"
export * from "./EditDetails.vue?vue&type=script&lang=ts&"
import style0 from "./EditDetails.vue?vue&type=style&index=0&id=2bdf413e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdf413e",
  null
  
)

export default component.exports